import React, { useEffect, useState } from 'react'
import { Tabs } from '@mantine/core'
import '../../styles/admin/InquiryBox.css'
import { apiRequest } from '../../utils/api'
import { useLocation, useNavigate } from 'react-router-dom'
import MantineSelectBox from '../common/MantineSelectBox'
import SaveButton from '../common/SaveButton'
import { Select as MantineSelect } from '@mantine/core'
import BaseButton from '../common/BaseButton'
import styles from '../../styles/admin/Main.module.scss'
import { Pagination } from '@mantine/core'
import { useAuthStore } from '../../store'

const InquiryBox = () => {
  const [activeTab, setActiveTab] = useState('center')
  const [author, setAuthor] = useState('')
  const [title, setTitle] = useState('')
  const [sort, setSort] = useState('latest')

  // 탭별 독립적인 데이터와 페이지네이션 상태
  const [centerData, setCenterData] = useState([])
  const [memberData, setMemberData] = useState([])
  const [centerCurrentPage, setCenterCurrentPage] = useState(1)
  const [memberCurrentPage, setMemberCurrentPage] = useState(1)
  const [centerItemsPerPage, setCenterItemsPerPage] = useState(10)
  const [memberItemsPerPage, setMemberItemsPerPage] = useState(10)
  const user = useAuthStore((state) => state.user)
  const [centerID, setCenterID] = useState(0)
  const navigate = useNavigate()
  const location = useLocation()
  const fromTab = location.state?.fromTab || 'center'

  useEffect(() => {
    const center = user?.CENTER_ID || 0
    setCenterID(center)

    // 바로 조회 실행
    fetchBoardList(fromTab, center)
  }, [user])

  const fetchBoardList = async (tab = activeTab, centerOverride = centerID) => {
    try {
      const endpoint = tab === 'center' ? '/board-center' : '/board-user'

      const res = await apiRequest(endpoint, 'POST', {
        author,
        title,
        sort,
        centerID: centerOverride,
        USER_ID: user.USER_ID,
        STATUS: user.STATUS,
      })

      // 탭별로 데이터 설정
      if (tab === 'center') {
        setCenterData(res.data || [])
        setCenterCurrentPage(1)
      } else {
        setMemberData(res.data || [])
        setMemberCurrentPage(1)
      }
    } catch (err) {
      console.error('게시글 불러오기 실패', err)
      if (tab === 'center') {
        setCenterData([])
      } else {
        setMemberData([])
      }
    }
  }

  const handleTabChange = (value) => {
    setActiveTab(value)
    fetchBoardList(value)
  }

  const handleInquiryClick = () => {
    navigate('/inquiries/create', { state: { fromTab: activeTab } })
  }

  // 페이지네이션 관련 함수들
  const handlePageChange = (page, tab) => {
    if (tab === 'center') {
      setCenterCurrentPage(page)
    } else {
      setMemberCurrentPage(page)
    }
  }

  const handleItemsPerPageChange = (value, tab) => {
    const numValue = parseInt(value.replace('entries', ''))
    if (tab === 'center') {
      setCenterItemsPerPage(numValue)
      setCenterCurrentPage(1)
    } else {
      setMemberItemsPerPage(numValue)
      setMemberCurrentPage(1)
    }
  }

  // 현재 페이지에 표시할 데이터 계산
  const getCurrentPageData = (tab) => {
    const data = tab === 'center' ? centerData : memberData
    const currentPage = tab === 'center' ? centerCurrentPage : memberCurrentPage
    const itemsPerPage =
      tab === 'center' ? centerItemsPerPage : memberItemsPerPage

    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return data.slice(startIndex, endIndex)
  }

  const getTotalPages = (tab) => {
    const data = tab === 'center' ? centerData : memberData
    const itemsPerPage =
      tab === 'center' ? centerItemsPerPage : memberItemsPerPage
    return Math.ceil(data.length / itemsPerPage)
  }

  const getCurrentPage = (tab) => {
    return tab === 'center' ? centerCurrentPage : memberCurrentPage
  }

  const getItemsPerPage = (tab) => {
    return tab === 'center' ? centerItemsPerPage : memberItemsPerPage
  }

  // 검색 초기화 함수
  const handleReset = () => {
    setAuthor('')
    setTitle('')
    setSort('latest')
    if (activeTab === 'center') {
      setCenterCurrentPage(1)
    } else {
      setMemberCurrentPage(1)
    }
  }

  // 검색 함수
  const handleSearch = () => {
    if (activeTab === 'center') {
      setCenterCurrentPage(1)
    } else {
      setMemberCurrentPage(1)
    }
    fetchBoardList()
  }

  // 정렬 변경 함수
  const handleSortChange = (value) => {
    setSort(value)
    if (activeTab === 'center') {
      setCenterCurrentPage(1)
    } else {
      setMemberCurrentPage(1)
    }
    fetchBoardList()
  }

  const renderTableContent = (tab) => {
    const currentData = getCurrentPageData(tab)
    const totalPages = getTotalPages(tab)
    const currentPage = getCurrentPage(tab)
    const itemsPerPage = getItemsPerPage(tab)

    return (
      <>
        <div className="uploads-search-section">
          <div className="filters">
            <input
              className="search-input"
              type="text"
              placeholder="Author"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
            />
            <input
              className="search-input"
              type="text"
              placeholder="Title"
              value={title}
              id="filter-title"
              onChange={(e) => setTitle(e.target.value)}
            />
            <MantineSelectBox
              value={sort}
              onChange={handleSortChange}
              options={[
                { value: 'latest', label: 'Newest' },
                { value: 'oldest', label: 'Oldest' },
              ]}
            />
          </div>

          <div className="search-buttons">
            <SaveButton onClick={handleReset}>Reset</SaveButton>
            <SaveButton onClick={handleSearch}>Search</SaveButton>
          </div>
        </div>

        <div className="add-button-container">
          <BaseButton onClick={handleInquiryClick}>Write</BaseButton>
        </div>

        <table className="inquiry-table">
          <colgroup>
            <col width="10%" />
            <col width="40%" />
            <col width="10%" />
            <col width="20%" />
            <col width="20%" />
          </colgroup>
          <thead>
            <tr>
              <th>Order</th>
              <th>Title</th>
              <th>Author</th>
              <th>Author Type</th>
              <th>Date Registered</th>
            </tr>
          </thead>
          <tbody>
            {currentData.map((row, index) => (
              <tr key={row.ID}>
                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td
                  className="clickable"
                  onClick={() => navigate(`/inquiries/detail/${row.ID}`)}
                >
                  {row.TITLE}
                </td>
                <td>{row.SENDER_ID}</td>
                <td>{row.ROLE}</td>
                <td>{row.REG_DTM}</td>
              </tr>
            ))}

            {/* 데이터가 없을 때 메시지 표시 */}
            {currentData.length === 0 && (
              <tr>
                <td
                  colSpan="5"
                  style={{ textAlign: 'center', padding: '20px' }}
                >
                  No Data Available..
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <br />
        <div className={styles.paginationWrapper}>
          <Pagination
            value={currentPage}
            onChange={(page) => handlePageChange(page, tab)}
            total={totalPages}
            size="sm"
            withEdges={false}
            color="gray"
            classNames={{
              control: styles.paginationControl,
            }}
          />
        </div>

        <div className="users-select-wrapper">
          <MantineSelect
            styles={{ input: { width: '150px', height: '40px' } }}
            data={['10entries', '20entries', '50entries']}
            value={`${itemsPerPage}entries`}
            onChange={(value) => handleItemsPerPageChange(value, tab)}
          />
        </div>
      </>
    )
  }

  return (
    <div className="inquiry-box">
      <Tabs color="blue" value={activeTab} onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab value="center" style={{ width: '50%' }}>
            To Center
          </Tabs.Tab>
          <Tabs.Tab value="member" style={{ width: '50%' }}>
            To Administrator
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="center" pt="lg">
          {renderTableContent('center')}
        </Tabs.Panel>

        <Tabs.Panel value="member" pt="lg">
          {renderTableContent('member')}
        </Tabs.Panel>
      </Tabs>
    </div>
  )
}

export default InquiryBox
